import BreadCrumbComp from "../components/BreadCrumbComp";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";
import Section3 from "./Sections/Section3";
import Section4 from "./Sections/Section4";
import PageSchema from "../components/PageSchema";

export default function AboutUs() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="About Prime Cloud Systems | High-Performance IT Hardware & Networking"
        description="At Prime Cloud Systems, we specialize in high-performance IT hardware and networking solutions at competitive prices. From servers and custom PCs to routers, switches, and components, we provide reliable technology solutions for home users, IT professionals, and businesses."
        url="https://primecloudsystems.com/about-us"
        breadcrumbs={[
          { name: "Home", url: "https://primecloudsystems.com/" },
          { name: "About Us", url: "https://primecloudsystems.com/about-us" },
        ]}
      />

      <BreadCrumbComp
        currentPage="About Us"
        title="About Prime Cloud Systems"
        description="Learn about Prime Cloud Systems, a trusted provider of high-performance IT hardware, accessories, and networking solutions. Our mission is to deliver top-quality, cost-effective technology that supports home users, IT professionals, and businesses with reliable and efficient IT infrastructure."
      />

      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </>
  );
}
